module.exports = __webpack_public_path__ + "assets/3b817daec3b6b38d72b154f9644776f5.png";